import '@/assets/scss/mobileFlexible.scss'

export function setup () {

}
